import React from "react";
import { useState } from "react";
import { Redirect } from "react-router-dom";
import { useTranslation } from 'react-i18next';

export default function EtatAbonAdmin(props) {
  const { t } = useTranslation();
  const [redirectInconnu, setRedirect] = useState(false);
  return (
    <main class="main-wrapper login-page">
      <div class="container-login">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (
              props.location.state &&
              props.location.state.abonnement &&
              ["ANNULE", "NON_ABONNEE"].includes(
                props.location.state.abonnement.statut
              )
            ) {
              window.location.replace(
                props.location.state.abonnement.urlAbonnement
              );
            } else {
              setRedirect(true);
            }
          }}
          class="box-login"
        >
          <h5 class="mb-4">
            {t('abonnement.subscription_inactive_title')}<br /><br />{t('abonnement.subscription_inactive_detail')}
          </h5>
          <button type="submit" class="btn-gradient mt-4">
            Accéder
          </button>
        </form>
        {redirectInconnu ? (
          <Redirect
            to={{
              pathname: "/abonnement-inconnu",
            }}
          />
        ) : (
          ""
        )}
      </div>
    </main>
  );
}
